import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Swiper from './_swiper.js'
import RaceCardsSkeleton from './_race-cards-skeleton.js'

export default {
  name: 'NextRaces',
  values: {
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            flexDirection: 'column',
          },
        },
      },
    },
    nextOffHeaderContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    nextOffHeader: {
      configSet: Text,
      configValues: {},
    },
    minEventsNumber: 3,
    swiper: {
      configSet: Swiper,
      configValues: {
        style: {
          padding: '16px 1px',
          gap: '8px',
          width: '100%',
          height: '247px',
        },
        slide: {
          style: {
            height: '100%',
            minHeight: '247px',
            flexBasis: '294px',
          },
        },
      },
    },
    raceCardsSkeleton: {
      configSet: RaceCardsSkeleton,
      configValues: {
        container: {
          style: {
            _mobile_padding: '0 8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
